/**
 * Clikker Creator Profile Platform Engine
 * Updated with properties[Mobile Number] for DB consistency
 */
document.addEventListener("DOMContentLoaded", function () {

  /* --- PROFILE SHARE SYSTEM --- */
  const shareBtn = document.getElementById('shareCreatorBtn');
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const title = shareBtn.dataset.title;
      const url = shareBtn.dataset.url;

      if (navigator.share) {
        try {
          await navigator.share({ title, text: title, url });
        } catch (e) {}
      } else {
        try {
          await navigator.clipboard.writeText(url);
          shareBtn.classList.add('copied');
          setTimeout(() => shareBtn.classList.remove('copied'), 1200);
        } catch (e) {}
      }
    });
  }

  /* --- STANDARDIZED LOCAL STORAGE --- */
  const storageKeys = {
    name: "clikker_buyer_name",
    email: "clikker_buyer_email",
    mobile: "clikker_buyer_mobile",
    instagram: "clikker_buyer_instagram"
  };

  function loadSavedData() {
    const name = localStorage.getItem(storageKeys.name);
    const email = localStorage.getItem(storageKeys.email);
    const mobile = localStorage.getItem(storageKeys.mobile);
    const instagram = localStorage.getItem(storageKeys.instagram);

    // Call Modal
    if (name) document.querySelector('#callDropModal input[name="properties[Buyer Name]"]')?.setAttribute('value', name);
    if (email) document.querySelector('#callDropModal input[name="properties[Email Address]"]')?.setAttribute('value', email);
    if (mobile) document.querySelector('#callDropModal input[name="properties[Mobile Number]"]')?.setAttribute('value', mobile);

    // Message Modal
    if (instagram) document.querySelector('#messageModal input[name="properties[Instagram Username]"]')?.setAttribute('value', instagram);
    if (mobile) document.querySelector('#messageModal input[name="properties[Mobile Number]"]')?.setAttribute('value', mobile);
  }

  function saveFormData(form) {
    if (!form) return;
    const name = form.querySelector('input[name="properties[Buyer Name]"]')?.value?.trim();
    const email = form.querySelector('input[name="properties[Email Address]"]')?.value?.trim();
    const mobile = form.querySelector('input[name="properties[Mobile Number]"]')?.value?.trim();
    const instagram = form.querySelector('input[name="properties[Instagram Username]"]')?.value?.trim();

    if (name) localStorage.setItem(storageKeys.name, name);
    if (email) localStorage.setItem(storageKeys.email, email);
    if (mobile) localStorage.setItem(storageKeys.mobile, mobile);
    if (instagram) localStorage.setItem(storageKeys.instagram, instagram);
  }

  loadSavedData();

  const callForm = document.getElementById('callBookingForm');
  const messageForm = document.getElementById('messageBookingForm');

  if (callForm) callForm.addEventListener('submit', () => saveFormData(callForm));
  if (messageForm) messageForm.addEventListener('submit', () => saveFormData(messageForm));

  /* --- CONSOLIDATED MODAL CONTROLLER --- */
  const modals = [
    { button: "openCallModal", modal: "callDropModal", close: ["closeCallModal"] },
    { button: "openMessageModal", modal: "messageModal", close: ["closeMessageModal"] }
  ];

  modals.forEach(config => {
    const btn = document.getElementById(config.button);
    const modalEl = document.getElementById(config.modal);
    
    if (!btn || !modalEl) return;

    function show() {
      modalEl.style.display = "block";
      modalEl.setAttribute("aria-hidden", "false");
      document.body.classList.add("support-modal-open");
      
      const firstField = modalEl.querySelector('input:not([type="hidden"]), textarea, select');
      if (firstField) firstField.focus();
    }

    function hide() {
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");
      document.body.classList.remove("support-modal-open");
      btn.focus();
    }

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      show();
    });

    config.close.forEach(id => {
      const closeBtn = document.getElementById(id);
      if (closeBtn) closeBtn.addEventListener("click", hide);
    });

    modalEl.addEventListener("click", (e) => {
      if (e.target === modalEl) hide();
    });
  });

  /* --- ESCAPE KEY --- */
  window.addEventListener("keydown", function(e) {
    if (e.key !== "Escape") return;
    
    document.querySelectorAll(".call-drop-modal").forEach(modal => {
      if (modal.style.display === "block") {
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("support-modal-open");
      }
    });
  });

});